// newsTagDefault: 初回アクセス時のタグコントロール

export default function newsTagDefault() {
  var get_data = location.search;
  if (get_data) {
    // パラメータの判別
    var term_name = get_data.replace(/\?term=/g, "");
    var target = '.c-genre_item[data-term_slug="' + term_name + '"]';
    // タブアクティブ
    $(target).toggleClass('is-active');
    $(target).siblings().removeClass('is-active');
    // パラメータの削除
    var replaceQueryString = location.origin + location.pathname;
    history.replaceState(null, null, replaceQueryString);
  }
}


// WEBPACK FOOTER //
// ./js/module/newsTagDefault.js